import { PureComponent } from 'react';
import { observer } from 'mobx-react';
import stateContext, { IState } from '~/ui/react/contexts/state';
import Toast from '~/ui/react/components/Toast';

class UiMessages extends PureComponent<IProps, any> {

    public static contextType = stateContext;

    protected uiStore: IState['ui'];

    /**
     * @param props
     * @param context
     */
    public constructor(props: IProps, context: IState) {
        super(props);
        this.uiStore = context.ui;
    }

    /**
     * @inheritDoc
     */
    public render() {
        const { uiStore } = this;
        const { message } = uiStore;

        const toastProps: any = {
            onClose: this.uiStore.clearMessage
        };

        if(message) {
            toastProps.children = message.text;
            toastProps.mode = message.type;
        }

        return <Toast {...toastProps} />;
    }
}

interface IProps extends React.HTMLProps<UiMessages> {

}

export default observer(UiMessages);
